import React, { useEffect, useState } from 'react';
import { PhoneIcon, MenuIcon, XIcon } from 'lucide-react';
export function Header() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Engagement Rings',
    href: '#engagement-rings'
  }, {
    name: 'Custom & Remodels',
    href: '#repairs'
  }, {
    name: 'Repairs',
    href: '#repairs'
  }, {
    name: 'Diamonds',
    href: '#diamonds'
  }, {
    name: 'Valuations',
    href: '#consultation'
  }, {
    name: 'About James',
    href: '#founder'
  }, {
    name: 'Visit',
    href: '#visit'
  }];
  return <header className={`sticky top-0 z-40 transition-all duration-300 ${scrolled ? 'bg-background/95 backdrop-blur-md shadow-sm border-b border-gold/20' : 'bg-background border-b border-gold/10'}`} data-id="element-317">
      <div className="container-custom" data-id="element-318">
        <div className={`flex items-center justify-between transition-all ${scrolled ? 'h-16' : 'h-20 md:h-24'}`} data-id="element-319">
          {/* Logo */}
          <a href="/" className="flex items-center shrink-0" data-id="element-320">
            <img src="https://cdn.magicpatterns.com/uploads/h2GZL1vXJEV8VZaWTvuTy7/new-sinclairs-logo-v1-jpg.webp" alt="Sinclairs Jewellers of Distinction — Established 1947" className={`transition-all ${scrolled ? 'h-10' : 'h-14 md:h-16'} w-auto object-contain`} data-id="element-321" />
          </a>

          {/* Desktop Nav */}
          <nav className="hidden lg:flex items-center gap-7" data-id="element-322">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-[0.85rem] font-medium text-secondary hover:text-gold-dark transition-colors tracking-wide" data-id="element-323">
                {link.name}
              </a>)}
          </nav>

          {/* Desktop Actions */}
          <div className="hidden md:flex items-center gap-4 shrink-0" data-id="element-324">
            <a href="tel:0893162321" className="flex items-center gap-2 text-sm font-medium text-primary hover:text-gold-dark transition-colors" data-id="element-325">
              <PhoneIcon className="w-4 h-4 text-gold" data-id="element-326" />
              <span className="hidden xl:inline" data-id="element-327">08 9316 2321</span>
            </a>
            <a href="#consultation" className="btn-primary py-2.5 px-5 text-xs" data-id="element-328">
              Book Consultation
            </a>
          </div>

          {/* Mobile Menu Toggle */}
          <button className="md:hidden p-2 text-primary" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" data-id="element-329">
            {isMobileMenuOpen ? <XIcon className="w-6 h-6" data-id="element-330" /> : <MenuIcon className="w-6 h-6" data-id="element-331" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && <div className="md:hidden absolute top-full left-0 right-0 bg-surface border-b border-gold/20 shadow-lg" data-id="element-332">
          <nav className="container-custom py-6 flex flex-col gap-1" data-id="element-333">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-base font-medium text-primary py-3 px-2 border-b border-paper hover:text-gold-dark transition-colors" onClick={() => setIsMobileMenuOpen(false)} data-id="element-334">
                {link.name}
              </a>)}
            <div className="flex gap-3 pt-5" data-id="element-335">
              <a href="tel:0893162321" className="btn-secondary flex-1 py-3 text-xs" data-id="element-336">
                <PhoneIcon className="w-4 h-4 mr-2 text-gold" data-id="element-337" />
                Call
              </a>
              <a href="#consultation" className="btn-primary flex-1 py-3 text-xs" onClick={() => setIsMobileMenuOpen(false)} data-id="element-338">
                Book Consultation
              </a>
            </div>
          </nav>
        </div>}
    </header>;
}